import {BaseUserFlow, UserFlowList, UserFlowStep} from './BaseUserFlow';
import {UserFlowType} from './UserFlowFacade';
import {ROUTE_ASSISTANT} from '../../Constants';

export class ProjectStartUserFlow extends BaseUserFlow {
  protected readonly type = UserFlowType.Start;
  protected readonly canCancel = false;

  public setNextStep() {
    const nextStep = super.setNextStep();

    return nextStep;
  }

  public canChangeStep(step: string): boolean {
    const stepParts = step.split('.');
    const currentStepParts = this.getCurrentStep().split('.');

    // Check that the userflow types match.
    if (stepParts[0] === currentStepParts[0]) {
      // Logic based on the userflow type.
      switch (true) {
        case UserFlowType.Auth === currentStepParts[0]: {
          if (stepParts[1] === UserFlowStep.None) return false;
          return true;
        }
      }
    }

    return true;
  }

  /**
   * @inheritdoc
   */
  public configure(): UserFlowList {
    super.configure();

    const newSteps: UserFlowList = [];

    const guestWorkflowMode = this.getGuestWorkflowModeFlow();
    if (null !== guestWorkflowMode) {
      newSteps.push(`${UserFlowStep.Auth}.${guestWorkflowMode}`);
    }

    const upgradePrompt = this.getPromptUpgradeOnOpen();
    if (null !== upgradePrompt) {
      newSteps.push(`${UserFlowType.Upgrade}.${UserFlowStep.Upgrade}`);
    }

    const optionsAndExtras = this.getOptionsAndExtrasOnOpen();
    if (null !== optionsAndExtras) {
      newSteps.push(`${UserFlowType.OptionsAndExtras}.${UserFlowStep.OptionsAndExtras}`);
    }

    return newSteps;
  }
}
